<template>
    <div>

        <el-form label-position="top">

            <el-tabs type="border-card" v-model="tabAtivo">
                <el-tab-pane label="FILTROS" name="filtros">

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Instituição" key="instituicao" v-if="$store.state.user.tipo == 10 || ($store.state.user.tipo > 3 && $store.state.user.tipo <= 8)">
                                <el-select ref="instituicao_id" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição" clearable>
                                    <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                                </el-select>
                            </el-form-item>
                            <div class="style-form" v-if="$store.state.user.tipo <=3 || $store.state.user.tipo == 9">
                                <label>Instituição</label>
                                <div class="style-input readonly">{{ $store.state.config.instituicao.nome }}</div>
                            </div>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Pesquisar (nome/apelido/INEP)" key="query">
                                <el-input v-model="filtro.query" placeholder="Digite para filtrar" @blur="formatData('query', 2)" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Situação de Funcionamento" prop="situacao_funcionamento" key="situacao_funcionamento">
                                <el-select ref="situacao_funcionamento" v-model="filtro.situacao_funcionamento" clearable multiple>
                                    <el-option v-for="(item, i) in $CONSTANTS.SITUACAO_FUNCIONAMENTO" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Zona" prop="localizacao_zona" key="localizacao_zona">
                                <el-select ref="localizacao_zona" v-model="filtro.localizacao_zona" clearable>
                                    <el-option v-for="(item, i) in $CONSTANTS.LOCALIZACAO_ZONA" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="Participa Pré-matrícula?" prop="participa_pre_matricula" key="participa_pre_matricula">
                                <el-select ref="participa_pre_matricula" v-model="filtro.participa_pre_matricula" clearable>
                                    <el-option :key="1" label="SIM" :value="1"></el-option>
                                    <el-option :key="0" label="NÃO" :value="0"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="É Creche?" prop="creche" key="creche">
                                <el-select ref="creche" v-model="filtro.creche" clearable>
                                    <el-option :key="1" label="SIM" :value="1"></el-option>
                                    <el-option :key="0" label="NÃO" :value="0"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="Status Educacenso" prop="status_educacenso" key="status_educacenso">
                                <el-select ref="status_educacenso" v-model="filtro.status_educacenso" clearable>
                                    <el-option v-for="(item, i) in $CONSTANTS.STATUS_EDUCACENSO" :key="i" :label="item" :value="parseInt(i)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-tab-pane>

                <el-tab-pane label="CAMPOS" name="campos">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <label class="u-pl-5 u-mb-5" style="display: block; font-size: 15px;"><b>Campos de Instituição</b></label>
                            <div style="height: 260px; background-color: #f8f8f8; padding:10px;">
                                <el-checkbox-group v-model="campos.instituicao" class="checkbox-filtos">
                                    <el-checkbox label="nome">Nome</el-checkbox>
                                    <el-checkbox label="apelido">Apelido</el-checkbox>
                                    <el-checkbox label="inep">INEP</el-checkbox>
                                    <el-checkbox label="situacao_funcionamento">Situação de Funcionamento</el-checkbox>
                                    <el-checkbox label="localizacao_zona">Zona</el-checkbox>
                                    <el-checkbox label="distrito">Distrito</el-checkbox>
                                    <el-checkbox label="cidade">Cidade</el-checkbox>
                                    <el-checkbox label="bairro">Bairro</el-checkbox>
                                    <el-checkbox label="telefone">Telefone</el-checkbox>
                                    <el-checkbox label="email">E-mail</el-checkbox>
                                    <el-checkbox label="participa_pre_matricula">Participa Pré-matrícula</el-checkbox>
                                    <el-checkbox label="creche">Creche</el-checkbox>
                                    <el-checkbox label="status_educacenso">Status Educacenso</el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </el-col>
                    </el-row>
                </el-tab-pane>
            </el-tabs>

            <div class="u-mt-10">
                <el-row>
                    <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                        <el-button @click="renderRelatorioGeralInstituicao('excel')" :loading="loadingButtonExcel" type="primary">EXCEL</el-button>
                        <el-button class="u-ml-10" @click="renderRelatorioGeralInstituicao('pdf')" :loading="loadingButtonPdf" type="primary">PDF</el-button>
                        <el-button class="u-ml-10" @click="renderRelatorioGeralInstituicao('html')" :loading="loadingButtonHtml" type="primary">HTML</el-button>
                        <el-button class="u-ml-10" @click="renderRelatorioGeralInstituicao('word')" :loading="loadingButtonWord" type="primary">WORD</el-button>
                        <el-button class="u-ml-10" @click="renderRelatorioGeralInstituicao('json')" :loading="loadingButtonJson" type="primary">JSON</el-button>
                    </el-col>
                </el-row>
            </div>

        </el-form>

    </div>
</template>

<script>
import cPanel from '../../../shared/c-panel/c-panel.vue';

export default {
    components: { cPanel },
    data: () => ({
        tabAtivo: 'filtros',
        loadingButtonExcel: false,
        loadingButtonPdf: false,
        loadingButtonHtml: false,
        loadingButtonWord: false,
        loadingButtonJson: false,
        ref: [],
        campos:{
            instituicao: [
                'nome',
                'inep',
                'situacao_funcionamento',
                'localizacao_zona',
                'cidade',
                'bairro'
            ]
        },
        filtro: {
            instituicao_id: '',
            situacao_funcionamento: [1],
            localizacao_zona: '',
            participa_pre_matricula: '',
            creche: '',
            status_educacenso: '',
            query: '',
        },
    }),
    mounted () {
        if(this.$store.state.user.tipo <=3 || this.$store.state.user.tipo == 9){
            this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
        }
    },
    methods: {
        renderRelatorioGeralInstituicao(tipo){

            if(this.campos.instituicao.length == 0){
                window.eventBus.$emit('alert', {msg: 'É necessário selecionar, pelo menos, um campo a ser apresentado no relatório.', type: 'warning'});
                return false;
            }

            this.ref = [];

            if((this.$store.state.user.tipo <=3 || this.$store.state.user.tipo == 9) && this.$store.state.config?.instituicao?.nome){
                this.ref.push({ nome: 'Instituição', valor: this.$store.state.config.instituicao.nome });
            }else if(this.$refs.instituicao_id && this.$refs.instituicao_id.selected){
                this.ref.push({ nome: 'Instituição', valor: this.$refs.instituicao_id.selected.label });
            }

            if(this.$refs.situacao_funcionamento?.selected?.length > 0){
                this.addMultipleSelectFieldToRefFilter('Situação de Funcionamento', this.$refs.situacao_funcionamento.selected);
            }

            if(this.$refs.localizacao_zona?.selected?.label){
                this.ref.push({ nome: 'Zona', valor: this.$refs.localizacao_zona.selected.label });
            }

            if(this.$refs.participa_pre_matricula?.selected?.label){
                this.ref.push({ nome: 'Participa Pré-matrícula', valor: this.$refs.participa_pre_matricula.selected.label });
            }

            if(this.$refs.creche?.selected?.label){
                this.ref.push({ nome: 'Creche', valor: this.$refs.creche.selected.label });
            }

            if(this.$refs.status_educacenso?.selected?.label){
                this.ref.push({ nome: 'Status Educacenso', valor: this.$refs.status_educacenso.selected.label });
            }

            if(this.filtro.query){
                this.ref.push({ nome: 'Pesquisar', valor: this.filtro.query });
            }

            if(tipo == 'pdf'){
                this.loadingButtonPdf = true;
                this.renderPdfRelatorioGeralInstituicao();
            }else if(tipo == 'html'){
                this.loadingButtonHtml = true;
                this.renderHtmlRelatorioGeralInstituicao();
            }else if(tipo == 'excel'){
                this.loadingButtonExcel = true;
                this.renderExcelRelatorioGeralInstituicao();
            }else if(tipo == 'word'){
                this.loadingButtonWord = true;
                this.renderWordRelatorioGeralInstituicao();
            }else if(tipo == 'json'){
                this.loadingButtonJson = true;
                this.renderJsonRelatorioGeralInstituicao();
            }
        },

        renderPdfRelatorioGeralInstituicao(){
            window.eventBus.$emit('print', {url: '/api/pdf/renderRelatorioGeralInstituicao/pdf', param: {ref: this.ref, filtros: this.filtro, campos: this.campos}});
            this.loadingButtonPdf = false;
        },

        renderExcelRelatorioGeralInstituicao(){
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pdf/renderRelatorioGeralInstituicao/excel`, { param: {ref: this.ref, filtros: this.filtro, campos: this.campos} }, this.$store.getters.getHeaderAuthExcel).then(response => {
                this.loadingButtonExcel = false;
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'relatorio.xlsx');
                document.body.appendChild(link);
                link.click();
            }).catch((error) => { this.loadingButtonExcel = false; this.$store.commit('throwException', error); });
        },

        renderWordRelatorioGeralInstituicao(){
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pdf/renderRelatorioGeralInstituicao/word`, { param: {ref: this.ref, filtros: this.filtro, campos: this.campos} }, this.$store.getters.getHeaderAuthExcel).then(response => {
                this.loadingButtonWord = false;
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'relatorio.docx');
                document.body.appendChild(link);
                link.click();
            }).catch((error) => { this.loadingButtonWord = false; this.$store.commit('throwException', error); });
        },

        renderJsonRelatorioGeralInstituicao(){
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pdf/renderRelatorioGeralInstituicao/json`, { param: {ref: this.ref, filtros: this.filtro, campos: this.campos} }, this.$store.getters.getHeaderAuthExcel).then(response => {
                this.loadingButtonJson = false;
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'relatorio.json');
                document.body.appendChild(link);
                link.click();
            }).catch((error) => { this.loadingButtonJson = false; this.$store.commit('throwException', error); });
        },

        async renderHtmlRelatorioGeralInstituicao(){
            try{
                let response = await this.getCodAutorizacaoRelatorioHtml();
                window.open(`${process.env.VUE_APP_BASE_URL}/api/relatorio/open/${response.data.token}`);
                this.loadingButtonHtml = false;
            }catch(e){
                this.loadingButtonHtml = false;
                window.eventBus.$emit('alert', {msg: 'Erro ao gerar relatório.', type: 'warning'});
            }
        },

        getCodAutorizacaoRelatorioHtml(){
            return this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/relatorio/generateCodAutorizacaoPrintHtml/geral-instituicoes`, {ref: this.ref, filtros: this.filtro, campos: this.campos}, this.$store.getters.getHeaderAuth);
        },

        formatData(field, size = null){
            if(!this.filtro[field]) return false;
            if(size && this.filtro[field].length < size) this.filtro[field] = '';
            this.filtro[field] = this.filtro[field].toUpperCase();
            this.filtro[field] = this.$removerAcentos(this.filtro[field]);
        },

        addMultipleSelectFieldToRefFilter(name, valuesSelected){
            const temp = { nome: name, valor: [] }
            valuesSelected.forEach(element => {
                temp.valor.push(element.currentLabel);
            });
            this.ref.push(temp);
        }
    }
}
</script>

